<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="row">
            <div class="col-12">
                <h1 class="title-default">Categorias Financeiras Padrão</h1>
                <p class="welcome-message">
                    <button mat-icon-button type="button" (click)="voltar()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    Vincule automaticamente categorias financeiras às operações do sistema.
                </p>
            </div>
        </div>

        @if (isLoading) {
        <!-- VENDA -->
        <div class="section-container">
            <app-loading-box height="24" width="150" marginTop="0"></app-loading-box>
            <div class="row mt-3">
                @for (item of [1,2,3]; track item) {
                <div class="col-12 col-md-4 mb-3">
                    <app-loading-box height="56" width="100%" marginTop="0"></app-loading-box>
                </div>
                }
            </div>
        </div>

        <!-- RECEBIMENTO -->
        <div class="section-container">
            <app-loading-box height="24" width="180" marginTop="0"></app-loading-box>
            <div class="row mt-3">
                @for (item of [1,2,3,4,5]; track item) {
                <div class="col-12 col-md-4 mb-3">
                    <app-loading-box height="56" width="100%" marginTop="0"></app-loading-box>
                </div>
                }
            </div>
        </div>

        <!-- COMPRA -->
        <div class="section-container">
            <app-loading-box height="24" width="150" marginTop="0"></app-loading-box>
            <div class="row mt-3">
                @for (item of [1,2]; track item) {
                <div class="col-12 col-md-4 mb-3">
                    <app-loading-box height="56" width="100%" marginTop="0"></app-loading-box>
                </div>
                }
            </div>
        </div>

        <!-- PAGAMENTO -->
        <div class="section-container">
            <app-loading-box height="24" width="180" marginTop="0"></app-loading-box>
            <div class="row mt-3">
                @for (item of [1,2,3]; track item) {
                <div class="col-12 col-md-4 mb-3">
                    <app-loading-box height="56" width="100%" marginTop="0"></app-loading-box>
                </div>
                }
            </div>
        </div>
        
        <app-loading-box height="70" width="100%" marginTop="0"></app-loading-box>
        } @else {
        <form [formGroup]="form">

            <!-- VENDA -->
            <div class="section-container">
                <div class="section-title">
                    <mat-icon>storefront</mat-icon>
                    <span>Venda</span>
                    <mat-icon class="info-icon" matTooltip="Categorias vinculadas automaticamente nas operações de venda."
                        matTooltipPosition="above">info_outline</mat-icon>
                </div>
                <div class="row mt-3">
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Fretes recebidos</mat-label>
                            <mat-select formControlName="idCategoriaVendaFrete">
                                <mat-option [value]="null">Nenhuma</mat-option>
                                @for (cat of opcoesCategorias; track cat.idCategoriaFinanceira) {
                                <mat-option [value]="cat.idCategoriaFinanceira">{{ cat.descricao }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Impostos retidos</mat-label>
                            <mat-select formControlName="idCategoriaVendaImposto">
                                <mat-option [value]="null">Nenhuma</mat-option>
                                @for (cat of opcoesCategorias; track cat.idCategoriaFinanceira) {
                                <mat-option [value]="cat.idCategoriaFinanceira">{{ cat.descricao }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Desconto concedido</mat-label>
                            <mat-select formControlName="idCategoriaVendaDesconto">
                                <mat-option [value]="null">Nenhuma</mat-option>
                                @for (cat of opcoesCategorias; track cat.idCategoriaFinanceira) {
                                <mat-option [value]="cat.idCategoriaFinanceira">{{ cat.descricao }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <!-- RECEBIMENTO -->
            <div class="section-container">
                <div class="section-title">
                    <mat-icon>arrow_downward</mat-icon>
                    <span>Recebimentos</span>
                    <mat-icon class="info-icon"
                        matTooltip="Categorias vinculadas automaticamente nas baixas do Contas a Receber."
                        matTooltipPosition="above">info_outline</mat-icon>
                </div>
                <div class="row mt-3">
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Multas recebidas</mat-label>
                            <mat-select formControlName="idCategoriaRecebimentoMulta">
                                <mat-option [value]="null">Nenhuma</mat-option>
                                @for (cat of opcoesCategorias; track cat.idCategoriaFinanceira) {
                                <mat-option [value]="cat.idCategoriaFinanceira">{{ cat.descricao }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Descontos concedidos</mat-label>
                            <mat-select formControlName="idCategoriaRecebimentoDesconto">
                                <mat-option [value]="null">Nenhuma</mat-option>
                                @for (cat of opcoesCategorias; track cat.idCategoriaFinanceira) {
                                <mat-option [value]="cat.idCategoriaFinanceira">{{ cat.descricao }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Juros recebidos</mat-label>
                            <mat-select formControlName="idCategoriaRecebimentoJuros">
                                <mat-option [value]="null">Nenhuma</mat-option>
                                @for (cat of opcoesCategorias; track cat.idCategoriaFinanceira) {
                                <mat-option [value]="cat.idCategoriaFinanceira">{{ cat.descricao }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Taxas pagas</mat-label>
                            <mat-select formControlName="idCategoriaRecebimentoTaxa">
                                <mat-option [value]="null">Nenhuma</mat-option>
                                @for (cat of opcoesCategorias; track cat.idCategoriaFinanceira) {
                                <mat-option [value]="cat.idCategoriaFinanceira">{{ cat.descricao }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Perdas (parcela dada como perda)</mat-label>
                            <mat-select formControlName="idCategoriaRecebimentoPerda">
                                <mat-option [value]="null">Nenhuma</mat-option>
                                @for (cat of opcoesCategorias; track cat.idCategoriaFinanceira) {
                                <mat-option [value]="cat.idCategoriaFinanceira">{{ cat.descricao }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <!-- COMPRA -->
            <div class="section-container">
                <div class="section-title">
                    <mat-icon>shopping_cart</mat-icon>
                    <span>Compras</span>
                    <mat-icon class="info-icon" matTooltip="Categorias vinculadas automaticamente nas operações de compra."
                        matTooltipPosition="above">info_outline</mat-icon>
                </div>
                <div class="row mt-3">
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Fretes pagos</mat-label>
                            <mat-select formControlName="idCategoriaCompraFrete">
                                <mat-option [value]="null">Nenhuma</mat-option>
                                @for (cat of opcoesCategorias; track cat.idCategoriaFinanceira) {
                                <mat-option [value]="cat.idCategoriaFinanceira">{{ cat.descricao }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Descontos obtidos</mat-label>
                            <mat-select formControlName="idCategoriaCompraDesconto">
                                <mat-option [value]="null">Nenhuma</mat-option>
                                @for (cat of opcoesCategorias; track cat.idCategoriaFinanceira) {
                                <mat-option [value]="cat.idCategoriaFinanceira">{{ cat.descricao }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <!-- PAGAMENTO -->
            <div class="section-container">
                <div class="section-title">
                    <mat-icon>arrow_upward</mat-icon>
                    <span>Pagamentos</span>
                    <mat-icon class="info-icon"
                        matTooltip="Categorias vinculadas automaticamente nas baixas do Contas a Pagar."
                        matTooltipPosition="above">info_outline</mat-icon>
                </div>
                <div class="row mt-3">
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Multas pagas</mat-label>
                            <mat-select formControlName="idCategoriaPagamentoMulta">
                                <mat-option [value]="null">Nenhuma</mat-option>
                                @for (cat of opcoesCategorias; track cat.idCategoriaFinanceira) {
                                <mat-option [value]="cat.idCategoriaFinanceira">{{ cat.descricao }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Juros pagos</mat-label>
                            <mat-select formControlName="idCategoriaPagamentoJuros">
                                <mat-option [value]="null">Nenhuma</mat-option>
                                @for (cat of opcoesCategorias; track cat.idCategoriaFinanceira) {
                                <mat-option [value]="cat.idCategoriaFinanceira">{{ cat.descricao }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Descontos obtidos</mat-label>
                            <mat-select formControlName="idCategoriaPagamentoDesconto">
                                <mat-option [value]="null">Nenhuma</mat-option>
                                @for (cat of opcoesCategorias; track cat.idCategoriaFinanceira) {
                                <mat-option [value]="cat.idCategoriaFinanceira">{{ cat.descricao }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <app-alert-card type="info">
                <strong>Dica:</strong> Estas categorias serão vinculadas automaticamente ao lançar operações como
                fretes, juros, multas e descontos. Você poderá alterá-las manualmente em cada lançamento caso
                necessário.
            </app-alert-card>

        </form>
        }
    </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading" (cancelar)="voltar()"
    (salvar)="salvar()">
</app-footer-action>
